<template>
  <v-select
    class="mb-3"
    :items="items"
    :disabled="disabled"
    v-model="draft"
    :menu-props="{ maxHeight: 300 }"
    :label="label"
    multiple
    small-chips
    :hint="hint"
    :placeholder="placeholder"
    persistent-hint
  >
    <nx-seo-origin-chip :value="origin" v-if="!draft.length" slot="append"></nx-seo-origin-chip>
  </v-select>
</template>

<script>
import BaseField from '@/modules/seo/components/BaseField';
import NxSeoOriginChip from '@/modules/seo/components/OriginChip';
import config from '../config';

export default {
  name: 'nx-seo-robots-field',
  extends: BaseField,
  components: {
    NxSeoOriginChip,
  },
  data() {
    return {
      items: config.robotsFieldOptions,
    };
  },
  computed: {
    hint() {
      if (this.draft.length > 0) {
        return `Vista previa: ${this.draft.join(', ')}`;
      }
      return this.effectiveValue;
    },
    placeholder() {
      if (!this.inheritedValue) {
        return null;
      }
      return this.inheritedValue.value.join(', ');
    },
  },
};
</script>

<style lang="stylus" scoped>
.showPointer {
  cursor: pointer;
}
</style>
